import { Injectable } from '@angular/core';

import { select } from '@ngrx/store';
import { filter, map, pairwise, shareReplay, skipWhile } from 'rxjs/operators';

import * as fromRouterSelectors from '../selectors/router.selectors';
import { Back, RouterFacade as SharedRouterFacade } from '@rx-applications/shared/data-access';

@Injectable({
  providedIn: 'root',
})
export class RouterFacade extends SharedRouterFacade {
  url$ = this.store.pipe(select(fromRouterSelectors.selectUrl));
  currentRoute$ = this.store.select(fromRouterSelectors.selectCurrentRoute);
  isOnAccountPages$ = this.store.select(fromRouterSelectors.selectIsOnAccountPages);
  isOnTripHubPage$ = this.store.pipe(select(fromRouterSelectors.selectIsOnTripHubPages));
  isOnClientFieldPage$ = this.store.pipe(select(fromRouterSelectors.selectIsOnClientFieldPages));

  isOnGuestDetailsPage$ = this.store.pipe(select(fromRouterSelectors.selectIsOnGuestDetailsPage));
  isOnApprovalRequestPage$ = this.store.pipe(select(fromRouterSelectors.selectIsOnApprovalRequestPage));

  isOnGuestDetailsGatewayPage$ = this.store.pipe(select(fromRouterSelectors.selectIsOnGuestDetailsGatewayPage));

  numberOfNights$ = this.store.pipe(select(fromRouterSelectors.selectNumberOfNights));

  areSearchParamsSet$ = this.store.pipe(select(fromRouterSelectors.selectAreSearchParamsSet));

  selectLocationCode$ = this.store.pipe(select(fromRouterSelectors.selectLocationCode));

  queryParamStars$ = this.store.pipe(select(fromRouterSelectors.selectQueryParamStars));

  previousRoute$ = this.store.pipe(
    select(fromRouterSelectors.selectState),
    pairwise(),
    skipWhile((routePair) => routePair.some((routeItem) => !routeItem)),
    shareReplay(1),
    map(([previousRoute]) => previousRoute),
  );

  previousSearch$ = this.previousRoute$.pipe(
    filter((previousRoute) => !!previousRoute),
    map(({ queryParams }) => queryParams),
  );

  override navigateBack() {
    this.store.dispatch(new Back());
  }
}
